export const RATE_COMPETENCY = 1;            // Tỉ lệ đạt năng lực
export const RATE_TEACHING_ERROR = 2;        // Tỉ lệ lỗi giảng dạy
export const RATE_PASS_FINAL_1 = 4;          // Tỉ lệ pass Final lần 1
export const RATE_PASS_MIDTERM = 3;          // Tỉ lệ pass Midterm
export const INFORMATION_CONFIG_LIST = {
    [RATE_COMPETENCY]: [
        {key: 'code', label: 'Mã lỗi', type: 'text'},
        {key: 'metric', label: 'Chỉ số gặp vấn đề', type: 'text'},
        {key: 'lecturer', label: 'Giảng viên', type: 'text'},
        {key: 'standard', label: 'Tiêu chuẩn', type: 'text'},
        {key: 'standardClassRatio', label: 'Tỉ lệ lớp đạt tiêu chuẩn', type: 'text'},
        {key: 'timeRange', label: 'Thời gian đo lường', type: 'text', format: 'DD-MM-YYYY'},
        {key: 'reportTime', label: 'Thời gian báo lỗi', type: 'text'},
        {key: 'deadline', label: 'Deadline xử lý', type: 'text'},
        {
            key: 'failedClasses',
            label: 'Danh sách lớp không đạt tiêu chuẩn',
            type: 'textarea',
            class: 'col-lg-12 mb-0'
        }
    ],
    [RATE_TEACHING_ERROR]: [
        { key: 'code', label: 'Mã lỗi', type: 'text' },
        { key: 'metric', label: 'Chỉ số gặp vấn đề', type: 'text' },
        { key: 'lecturerGroup', label: 'Nhóm giảng viên', type: 'text' },
        { key: 'standard', label: 'Tiêu chuẩn', type: 'text' },
        { key: 'errorShiftRatio', label: 'Tỉ lệ số ca học bị lỗi', type: 'text' },
        { key: 'timeRange', label: 'Thời gian đo lường', type: 'text', format: 'DD-MM-YYYY' },
        { key: 'reportTime', label: 'Thời gian báo lỗi', type: 'text' },
        { key: 'deadline', label: 'Deadline xử lý', type: 'text' },
        {
            key: 'failedLecturers',
            label: 'Danh sách giảng viên không đạt tiêu chuẩn',
            type: 'textarea',
            class: 'col-lg-12 mb-0'
        }
    ],
    [RATE_PASS_FINAL_1]: [
        { key: 'code', label: 'Mã lỗi', type: 'text' },
        { key: 'metric', label: 'Chỉ số gặp vấn đề', type: 'text' },

        { key: 'lecturer', label: 'Giảng viên', type: 'text' },
        {
            key: 'className',
            label: 'Lớp học',
            type: 'text',
            suffixAction: {
                type: 'link',
                text: 'Xem chi tiết',
                actionKey: 'viewClassDetail'
            }
        },

        { key: 'standard', label: 'Tiêu chuẩn', type: 'text' },
        { key: 'finalPassRatio', label: 'Tỉ lệ pass Final lần 1', type: 'text' },

        { key: 'timeRange', label: 'Thời gian đo lường', type: 'text', format: 'DD-MM-YYYY' },
        { key: 'reportTime', label: 'Thời gian báo lỗi', type: 'text' },

        {
            key: 'deadline',
            label: 'Deadline xử lý',
            type: 'text',
            class: 'col-lg-12 mb-0'
        }
    ],
    [RATE_PASS_MIDTERM]:  [
        { key: 'code', label: 'Mã lỗi', type: 'text' },
        { key: 'metric', label: 'Chỉ số gặp vấn đề', type: 'text' },

        { key: 'lecturer', label: 'Giảng viên', type: 'text' },
        {
            key: 'className',
            label: 'Lớp học',
            type: 'text',
            // optional: dùng để vẽ nút/link "Xem chi tiết"
            suffixAction: {
                type: 'link',
                text: 'Xem chi tiết',
                actionKey: 'viewClassDetail'
            }
        },

        { key: 'standard', label: 'Tiêu chuẩn', type: 'text' },
        { key: 'midtermPassRatio', label: 'Tỉ lệ pass midterm', type: 'text' },

        { key: 'timeRange', label: 'Thời gian đo lường', type: 'text', format: 'DD-MM-YYYY' },
        { key: 'reportTime', label: 'Thời gian báo lỗi', type: 'text' },

        {
            key: 'deadline',
            label: 'Deadline xử lý',
            type: 'text',
            class: 'col-lg-12 mb-0' // cho ô cuối cùng full width như trong ảnh
        }
    ]
}

export const SOLUTION_LIST = {
    [RATE_COMPETENCY]: [
        {value: 1, label: 'Giảng viên chủ động xử lý'},
        {value: 2, label: 'Học bổ trợ với Admin gia sư'},
        {value: 3, label: 'Học bổ trợ với Giảng viên Fulltime'},
        {value: 4, label: 'Phương án khác'},
    ],
    [RATE_TEACHING_ERROR]: [
        {value: 1, label: 'Nhắc nhở & theo dõi giảng viên'},
        {value: 2, label: 'Phạt công giảng viên & theo dõi'},
        {value: 3, label: 'Thử thách 14 ngày'},
        {value: 4, label: 'Sàng lọc'},
        {value: 5, label: 'Phương án khác'}
    ],
    [RATE_PASS_FINAL_1]: [
        {value: 1, label: 'Giảng viên chủ động xử lý'},
        {value: 2, label: 'Phương án khác'}
    ],
    [RATE_PASS_MIDTERM]: [
        {value: 1, label: 'Giảng viên chủ động xử lý'},
        {value: 2, label: 'Học bổ trợ với Admin gia sư'},
        {value: 3, label: 'Học bổ trợ với Giảng viên Fulltime'},
        {value: 4, label: 'Phương án khác'}
    ]
};
// Log kết quả xử lý (không có đo lường)
export const PROCESSING_RESULT_NO_MEASUREMENT = 'handling_without_measurement'

// Log kết quả xử lý (có đo lường)
export const PROCESSING_RESULT_WITH_MEASUREMENT = 'handling_with_measurement'

// Log kết quả đo lường (do hệ thống tạo)
export const MEASUREMENT_RESULT_SYSTEM = 'measurement_result'

export const COMPANY_LEVEL = 1
export const LECTURER_GROUP_LEVEL = 2
export const LECTURE_LEVEL = 3
export const CLASSROOM_LEVEL = 4
export const LEVEL_LIST = {
    [COMPANY_LEVEL] : 'group',
    [LECTURER_GROUP_LEVEL]: 'teacher',
    [LECTURE_LEVEL]:'class'
}